module.exports = __webpack_public_path__ + "static/media/checked.f21a637d.svg";